import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ImagesService } from '../core/service';
import { catchError, map, of } from 'rxjs';
import { environment } from '@/environments/environment';

@Injectable()
export class ImagesApiService implements ImagesService {
  private readonly defaultUrl = `${environment.apiHost}/images`;

  private cache: Record<string, string> = {};

  constructor(private httpClient: HttpClient) {}

  photo(id?: string) {
    if (id?.startsWith('http') || id?.startsWith('blob:')|| id?.startsWith('data:')) {
      return of(id);
    }

    if (!id) {
      return of(undefined);
    }

    if (this.cache[id]) {
      return of(this.cache[id]);
    }

    const url = `${this.defaultUrl}/${id}`;
    return this.httpClient
      .get(url, {
        responseType: 'blob',
        headers: {
          'Content-type': 'application/pdf',
        },
      })
      .pipe(
        map((blob) => {
          const target = URL.createObjectURL(blob);
          this.cache[id] = target;
          return target;
        }),
        catchError(() => of(undefined))
      );
  }
}
